import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-brand-cream border-t border-brand-sand py-12" data-id="element-67" data-mp="3gfsnyg23r0ok">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-68" data-mp="32nukakr5twzs">
        <h3 className="text-2xl font-serif font-bold text-brand-charcoal mb-2" data-id="element-69" data-mp="32pp5m06cfr4e">
          🏋️ PILATES 360™
        </h3>
        <p className="text-gray-600 mb-8" data-id="element-70" data-mp="36n3gdw9oa6yi">
          El sistema de planificación N°1 para profesores de Pilates argentinos.
        </p>

        <div className="flex flex-wrap justify-center gap-8 mb-12" data-id="element-71" data-mp="38zaivynj750">
          <a href="#" className="flex items-center gap-2 text-brand-charcoal hover:text-brand-terracotta transition-colors" data-id="element-72" data-mp="3lec9ifcsaage">
            <Mail size={20} data-id="element-73" data-mp="3qbvqhn0v91c1" /> contacto@pilates360.com.ar
          </a>
          <a href="#" className="flex items-center gap-2 text-brand-charcoal hover:text-brand-terracotta transition-colors" data-id="element-74" data-mp="29yxaz74xfaj6">
            <Instagram size={20} data-id="element-75" data-mp="3l9k4zam1djc8" /> @pilates360.ar
          </a>
          <a href="#" className="flex items-center gap-2 text-brand-charcoal hover:text-brand-terracotta transition-colors" data-id="element-76" data-mp="3la28msb12zu6">
            <Globe size={20} data-id="element-77" data-mp="3v89eog3s3xhe" /> www.pilates360.ar
          </a>
        </div>

        <div className="text-sm text-gray-500" data-id="element-78" data-mp="3q8n125k1gf82">
          © PILATES 360™ 2025 — Todos los derechos reservados.
          <br data-id="element-79" data-mp="82qthw25bzvb" />
          Prohibida la reproducción y redistribución sin autorización expresa.
        </div>
      </div>
    </footer>;
};